export default __webpack_public_path__ + "static/media/sign-out-dark.af7e62d5.svg";